import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { BookingsPage } from "@/features/bookings/pages/bookings-page";
import { bookingFilterSchema } from "@/features/bookings/schemas/booking-filter.schema";

export const Route = createFileRoute("/_authenticated/bookings/")({
	component: BookingsPage,
	validateSearch: zodValidator(bookingFilterSchema),
});
